import {Box, Card, CardMedia, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import ReactCardFlip from 'react-card-flip';
import {useEffect, useMemo, useState} from "react";

import Loading from "../../UI/Loading/Loading";
import {useGlobalContext} from "../../../services/context.service";
import {cardAPI} from "../../../services/cardAPI.service";
import {formatDriverCard} from "../../../utils/methods";
import {ICardsStatus} from "../../../services/response.interface";
import QRCard from "../DriverCards/SmartCard/QRCard";
import SmartCardContextMenu from "../DriverCards/SmartCard/SmartCardContextMenu";
import SmartCardFlip, {BoxContainer} from "../../Common/SmartCardFlip";
import {fnLocalizeFilter} from "../../../services/localize.service";


const Container = styled(Box)(() => ({
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    maxWidth: 330,
    maxHeight: 180,
    width: 310,
    height: 180,
    margin: "0 auto",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative"
}));

const NumCard = styled(Typography)(() => ({
    color: "#9b9b9b", position: "absolute", bottom: "30%", right: 10
}));

const FIOCard = styled(Typography)(() => ({
    color: "#9b9b9b", position: "absolute", bottom: "5%", right: 10
}));

const StatusCard = styled((props: any) => <Typography {...props}/>)((props) => {
    const {status} = props;

    return ({
        color: status === 0 ? "#a6ec92" : "#bb0109", position: "absolute", top: 7, left: 18
    })
});


const ContextMenu = styled(Box)(() => ({
    position: "absolute", right: 0, top: 0, zIndex: 1
}));


export default function MyCard() {
    /* Получаем языковую локаль */
    const {locale} = useGlobalContext();

    const [getCard, {data: dataCard, isLoading: isLoadingData} ]= cardAPI.useLazyFetchCardUserQuery();

    useEffect(()=>{
        getCard({locale});
    },[])

    if (isLoadingData) {
        return <BoxContainer><Loading type={"big"}/></BoxContainer>
    }

    if (!dataCard) {
        return <BoxContainer>{fnLocalizeFilter(locale, "_lang.module.cards.qr.notExistCard")}</BoxContainer>
    }


    return (<SmartCardFlip dataCard={dataCard}/>)
}
